import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/api";

export const FloatingWhatsApp = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chamar no WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200 }}
    className="pulse-ring fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--whatsapp)] text-black shadow-[0_10px_35px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110"
  >
    <MessageCircle size={26} strokeWidth={2.2} />
  </motion.a>
);
